/**
 * Created by josefjurca on 4/5/2018.
 */

import {
    convertForRead,
    convertFromRead
} from '../adapters/landingpage';

import LandingPage from 'models/landingpage';

/**
 * Gets and returns the landing page configuration.
 *
 * @param {string} configURL - Request params.
 * @returns {Promise} Get configuration promise.
 */
export function getLandingPage (configURL) {
    let data;

    data = convertForRead.call(this, configURL);

     return this.read({
            url: data.url,
            method: 'GET'
        })
        .catch(() => {
            return Promise.reject('Landing page could not be loaded.');
        })
        .then(response => {

            return new LandingPage(convertFromRead.call(this, response));
        });
}





// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/landingpage.js